<template>
    <v-text-field id="password-field" :label="`${$t('login.fields.labels.password')} *`" @input="$emit('input', $event)" :rules="rules"
                  :error-messages="error"></v-text-field>
</template>

<script>
    export default {
        name: 'PasswordField',
        props: {
            error: String,
        },
        computed: {
            rules ()
            {
                return [
                    v => !!v || this.$t('login.fields.rules.required'),
                ];
            },
        },
    };
</script>

<style scoped>

</style>